import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearUpdatedStudent } from '../../../store/actions/studentsActions'
import { fetchStudentTraits } from '../../../store/actions/traitsActions'
import CameraIcon from '../../elements/icons/CameraIcon'
import { calculateAge } from '../../../utils'
import StudentStatus from '../../elements/StudentStatus'
import PencilSquareIcon from '../../elements/icons/PencilSquareIcon'
import ModalDialog from '../../layouts/ModalDialog'
import AssignStudentStudyType from './AssignStudentStudyType'
import ManageStudentTraits from './ManageStudentTraits';

const StudentOverviewCard = ({student, reload}) => {
    const studentsSelector = useSelector((state) => state.students)
    const dispatch = useDispatch()
    const traitsSelector = useSelector(state => state.traits) 

    useEffect(() => {
        dispatch(fetchStudentTraits(`student=${student._id}`))

        if(studentsSelector?.updatedStudent !== null) {
            dispatch(clearUpdatedStudent())
            reload()
            setSettingStudentStudyType(false)
        }

        // fetchStudentTraits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [student?._id, dispatch, studentsSelector?.updatedStudent, traitsSelector?.updatedStudentTraits])

    const [settingStudentStudyType, setSettingStudentStudyType] = useState(false)
    const [traitsModalShown, setTraitsModalShown] = useState(false)
    
    return (
        <>
            <aside className='w-full overflow-hidden bg-white'>
                <div className='mx-auto flex h-[220px] w-full items-center justify-center bg-gray-50' style={{
                backgroundImage: `url(" ${student?.passportPhotograph} ")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat'
                }}>
                    {(!student?.passportPhotograph || student?.passportPhotograph === '') &&
                        <CameraIcon className={`w-8 h-8 text-gray-200`} />
                    }
                </div>
                <div className='py-5'>
                    <p className='font-space-grotesk text-base font-semibold text-gray-900'>
                        {`${student?.firstName || ''}${student?.otherNames ? ` ${student.otherNames.charAt(0)}.` : ''} ${student?.lastName || ''}`}
                    </p>
                    <p className='mt-1 text-xs uppercase tracking-[0.2em] text-vcm-dark-gray'>
                        {student?.admissionNumber || <span className='text-gray-400'>No student code</span>}
                    </p>

                    <div className='mt-5 rounded-lg bg-vcm-light-purple/20 flex items-start justify-between p-3'>
                        <div className='w-1/2'>
                            <p className='text-xs text-vcm-dark-gray'>Current class</p>
                            <p className='mt-1 text-sm font-medium text-gray-900'>
                                {student?.class?.class?.name || <span className='text-gray-400'>Not assigned</span>}
                                {student?.class?.division?.label}
                            </p>
                        </div>
                        <div className='w-1/2'>
                            <p className='text-xs text-vcm-dark-gray'>Study Type</p>
                            <div className="flex items-center gap-x-1">
                                <p className='mt-1 text-sm font-medium capitalize text-gray-900'>
                                    {student?.studyType?.toLowerCase() || <span className='text-gray-400'>Not assigned</span>}
                                </p>
                                {student?.class?.class?.type === 'SENIOR' && <button onClick={()=>{setSettingStudentStudyType(true)}} className='transition cursor-pointer duration-200 hover:bg-vcm-light-purple/20 rounded p-1 text-xs text-gray-700 flex items-center gap-x-1'>
                                    <PencilSquareIcon className="w-4 h-4" />
                                </button>}
                            </div>
                            
                        </div>
                    </div>

                    <div className='mt-3 grid grid-cols-2 gap-3'>
                        <div className='rounded-lg border border-gray-100 p-3'>
                            <p className='text-xs text-vcm-dark-gray'>Gender</p>
                            <p className='mt-1 capitalize text-sm font-medium text-gray-900'>
                                {student?.gender?.toLowerCase() || 'Not provided'}
                            </p>
                        </div>
                        <div className='rounded-lg border border-gray-100 p-3'>
                            <p className='text-xs text-vcm-dark-gray'>Age</p>
                            <p className='mt-1 font-space-grotesk text-sm font-medium text-gray-900'>
                                {student?.dob ? calculateAge(student?.dob) : 'Not provided'}
                            </p>
                        </div>
                    </div>

                    <div className='mt-3 rounded-lg border border-gray-100 p-3'>
                        <p className='text-xs text-vcm-dark-gray'>Status</p>
                        <div className='mt-1'>
                            <StudentStatus status={student?.status} />
                        </div>
                    </div>

                    <div className='mt-3 rounded-lg border border-gray-100 p-3'>
                        <div className="flex items-center justify-between gap-x-5 pb-2 border-b border-gray-100">
                            <p className='text-xs text-vcm-dark-gray '>Traits</p>

                            <button onClick={()=>{setTraitsModalShown(true)}} className="px-2 py-1 border border-gray-200 text-xs text-gray-600 rounded">Manage Traits</button>
                        </div>
                        <div className='mt-1'>
                            {traitsSelector?.loadingStudentTraits ?
                                <p className="text-xs text-gray-400">Loading traits...</p>
                            :
                                traitsSelector?.studentTraits?.studentTraits?.[0]?.traits?.length > 0 ?
                                    <div className=''>
                                        {traitsSelector?.studentTraits?.studentTraits?.[0]?.traits?.map((trait, index) => (
                                            <div key={index} className="mb-2">
                                                <div className='py-1 text-xs font-medium text-vcm-purple flex items-center justify-between mb-1'>
                                                    <p>
                                                        {trait.trait.name}
                                                    </p>
                                                    <p>{trait.score}</p>
                                                </div>
                                                <div className='h-1 bg-gray-200 rounded w-full'>
                                                    <div className={`h-1 rounded-full ${trait.score > 10 || trait.score < 5 ? 'bg-red-600' : trait.score < 7 && trait.score >= 5 ? 'bg-yellow-500' : 'bg-green-500'}`} style={{ 
                                                        width: `${trait.score * 10}%`,
                                                    }}></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                :
                                    <p className="text-xs text-gray-400">No traits information provided yet.</p>
                            }
                        </div>
                    </div>
                </div>
            </aside>

            <ModalDialog
                shown={settingStudentStudyType} 
                closeFunction={()=>{setSettingStudentStudyType(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Set Study Type'
                maxWidthClass='max-w-lg'
                hideActions={true}
            >
                <AssignStudentStudyType student={student} close={()=>{setSettingStudentStudyType(false)}} />
            </ModalDialog>

            <ModalDialog
                shown={traitsModalShown}
                closeFunction={()=>{setTraitsModalShown(false)}}
                dialogTitle="Manage Student Traits"
                maxWidthClass="max-w-lg"
                hideActions={true}
            >
                <ManageStudentTraits 
                    student={student} 
                    close={() => setTraitsModalShown(false)} 
                />
            </ModalDialog>
        </>
    )
}

export default StudentOverviewCard